import { defineComponent, computed } from 'vue';
import __vue_component__$1 from '../../../../../../alerts/Pane/Pane.vue.js';
import __vue_component__ from '../../../../../../cards/BasicCard/BasicCard.vue.js';

var script = defineComponent({
    name: 'AdditionalLocationInstructionsModal',
    components: {
        BasicCard: __vue_component__,
        Pane: __vue_component__$1,
    },
    props: {
        additionalInstructions: {
            type: String,
            required: true,
        },
        isOpened: {
            type: Boolean,
            required: true,
        },
    },
    emits: ['update:isOpened'],
    setup(props, { emit }) {
        const additionalInstructionsOpen = computed({
            get: () => props.isOpened,
            set: (value) => emit('update:isOpened', value),
        });
        return { additionalInstructionsOpen };
    },
});

export { script as default };
